// @flow
import * as React from 'react';
import {Fragment, useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import CalculationForm from "../../components/form/calculationForm";
import useCalculation from "../../hooks/useCalculation";
import useContribution from "../../hooks/useContribution";
import ContentLoader from "../../../../components/contentLoader/contentLoader";
import useRepayments from "../../hooks/useRepayments";
import {useLocation} from "react-router";
import Box from "@mui/material/Box";

import { RepaymentsProvider } from "../../hooks/RepaymentsContext";


const CreateInner = () => {
    let {id} = useParams()

    const location = useLocation()
    const queryParams = new URLSearchParams(location.search);
    const idFromUrlParams = queryParams.get('id');
    const [repaymentsLoadedOnce, setRepaymentsLoadedOnce] = useState(false);
    const [openRepaymentsTable, setOpenRepaymentsTable] = useState(false);

    if(idFromUrlParams){
        id = idFromUrlParams
    }

    const {contributions, interests, loading: loadingContributions} = useContribution()
    const {calculations, loading} = useCalculation({id})
    const {
        loading: repaymentsLoading,
        repayments,
        updateRepayments,
        handleUpdateRepayments,
        handleRemoveRepayment
    } = useRepayments({id})


    useEffect(() => {
    if (!repaymentsLoadedOnce) {
            setRepaymentsLoadedOnce(true);
        }
    }, [repaymentsLoading]);

    const isReady = !loading && !loadingContributions && repaymentsLoadedOnce  && (!id || Object.keys(calculations).length > 0);


    return isReady ? (
        <Fragment>
            {location.pathname === '/fast/calculation' ? (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: 'auto',
                        overflow: 'auto',
                        m: 2
                    }}
                >
                    <CalculationForm
                        id={id}
                        openRepaymentsTable={openRepaymentsTable}
                        setOpenRepaymentsTable={setOpenRepaymentsTable} 
                        repaymentsLoading={repaymentsLoading}
                        calculations={calculations}
                        contributions={contributions}
                        interests={interests}
                        repayments={repayments}
                        updateRepayments={updateRepayments}
                        handleUpdateRepayments={handleUpdateRepayments}
                        handleRemoveRepayment={handleRemoveRepayment}
                    />
                </Box>
            ) : (
                <CalculationForm
                    id={id}
                    openRepaymentsTable={openRepaymentsTable}
                    setOpenRepaymentsTable={setOpenRepaymentsTable} 
                    repaymentsLoading={repaymentsLoading}
                    calculations={calculations}
                    contributions={contributions}
                    interests={interests}
                    repayments={repayments}
                    updateRepayments={updateRepayments}
                    handleUpdateRepayments={handleUpdateRepayments}
                    handleRemoveRepayment={handleRemoveRepayment}
                />
            )}
        </Fragment>
    ) : (
        <ContentLoader
            loading={loading && loadingContributions && repaymentsLoading}
        />
    )
}



const Create = () => {
  return (
    <RepaymentsProvider>
      <CreateInner />
    </RepaymentsProvider>
  );
};

export default Create
// export default withPermissionHOC(Create, ['access_calculation_create'])